// src/components/header/SellorSidebar.tsx

import React from 'react';
import { FaShoppingBag, FaHome, FaChartLine, FaStore } from 'react-icons/fa'; // 필요한 아이콘 임포트

interface SellorSidebarProps {
  onMenuItemClick: (page: string) => void;
}

export default function SellorSidebar({ onMenuItemClick }: SellorSidebarProps) {
  // 로컬 스토리지에서 사용자 정보 가져오기
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div className="w-64 h-screen bg-white border-r px-6 py-8">
      <div className="flex items-center gap-3 mb-8">
        <div>
          {/* 프로필 이미지 */}
          <img
            src={`${process.env.REACT_APP_API_BASE_URL}${user.profileImageUrl}`}
            alt="Profile"
            className="shadow-sm w-[50px] h-[50px] rounded-full object-cover"
          />
        </div>
        <div className="flex flex-col">
          <span className="text-sm text-gray-500">
            {user.roles ? user.roles.join(', ') : '[등급 없음]'}
          </span>
          <h1 className="text-base font-bold text-[#111]">
            {user.nickname || '[닉네임 없음]'}
          </h1>
        </div>
      </div>

      <div className="mb-4">
        <ul className="space-y-4">
          {/* 홈 메뉴 항목 */}
          <li
            className="h-[40px] flex items-center text-sm font-bold text-gray-700 hover:text-MainColor cursor-pointer"
            onClick={() => onMenuItemClick('sellerPage')}
          >
            <FaHome className="mr-3" /> 홈
          </li>
          {/* 대시보드 메뉴 항목 */}
          <li
            className="h-[40px] flex items-center text-sm font-bold text-gray-700 hover:text-MainColor cursor-pointer"
            onClick={() => onMenuItemClick('dashboard')}
          >
            <FaChartLine className="mr-3" /> 대시보드
          </li>
          <li
            className="h-[40px] flex items-center text-sm font-bold text-gray-700 hover:text-MainColor cursor-pointer"
            onClick={() => onMenuItemClick('store')}
          >
            <FaStore className="mr-3" /> 스토어
          </li>
          <li
            className="h-[40px] flex items-center text-sm font-bold text-gray-700 hover:text-MainColor cursor-pointer"
            onClick={() => onMenuItemClick('shop')}
          >
            <FaShoppingBag className="mr-3" /> 상품
          </li>
          {/* 추가 메뉴 항목 가능 */}
        </ul>
      </div>
    </div>
  );
}
